import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  noPermission: {
    id: 'bitbucket.pipelines.action.no.permission',
    description: 'Message to show when no permission',
    defaultMessage: 'You do not have permission to stop the running pipeline',
  },
  inlineStop: {
    id: 'bitbucket.pipelines.list.inline.stop.tooltip',
    description: 'inline stop Tooltip message',
    defaultMessage: 'Stop',
  },
  stoppedBy: {
    id: 'bitbucket.pipelines.list.stopped.by',
    description: 'Stopped by message',
    defaultMessage: 'Stopped by {name}',
  },
});
